import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom"

// import Share from "../routes/Share"
import Auth from "../routes/Auth"
import Nav from "./Nav"
import Home from "../routes/Home"
import Profile from "../routes/Profile"
import List from "../routes/List"
import Finance from "../routes/Finance"
import Footer from "./Footer"
import Markdown from "../routes/Markdown"
import Usage from "../routes/Usage"
import AboutJace from "../routes/Jace"
import NotFound from "../routes/404"

const AppRouter = ({ refreshUser }) => {
  return (
    <div>
      <Router>
        <Routes>
          <>
            <Route
              exact
              path="/"
              element={
                <div style={{ height: "100vh" }}>
                  <Nav refreshUser={refreshUser} />
                  <Home />
                  <Footer />
                </div>
              }
            />
            <Route
              exact
              path="/auth"
              element={<Auth refreshUser={refreshUser} />}
            />
            <Route
              exact
              path="/profile"
              element={
                <div style={{ height: "100vh" }}>
                  <Nav refreshUser={refreshUser} />
                  <Profile refreshUser={refreshUser} />
                  <Footer />
                </div>
              }
            />
            <Route
              exact
              path="/finance"
              element={
                <div style={{ height: "100vh" }}>
                  <Nav refreshUser={refreshUser} />
                  <Finance refreshUser={refreshUser} />
                  <Footer />
                </div>
              }
            />
            {/* <Route
              exact
              path="/:shardId"
              element={
                <Share
                  refreshUser={refreshUser}
                />
              }
            /> */}
            <Route
              exact
              path="/usage"
              element={
                <div style={{ height: "100vh" }}>
                  <Nav refreshUser={refreshUser} />
                  <Usage />
                  <Footer />
                </div>
              }
            />
            <Route
              exact
              path="/about"
              element={
                <div style={{ height: "100vh" }}>
                  <Nav refreshUser={refreshUser} />
                  <AboutJace />
                  <Footer />
                </div>
              }
            />
            <Route
              exact
              path="/sample"
              element={
                <div style={{ height: "100vh" }}>
                  <Nav refreshUser={refreshUser} />
                  <List />
                  <Footer />
                </div>
              }
            />
            <Route
              path="/*"
              element={
                <div style={{ height: "100vh" }}>
                  <Nav refreshUser={refreshUser} />
                  <NotFound />
                  <Footer />
                </div>
              }
            />
          </>
        </Routes>
      </Router>
    </div>
  )
}

export default AppRouter
